var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._t("default"),_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.submitText || 'Uložiť'))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }